<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item prop="continent">
        <el-input v-model="queryParams.continent"  placeholder="大洲名称" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="countryName">
        <el-input v-model="queryParams.countryName"  placeholder="国家名称" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="operator">
        <el-input v-model="queryParams.operator"  placeholder="运营商名称" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="mccMnc">
        <el-input v-model="queryParams.mccMnc"  placeholder="运营商编码" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
      <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
    </el-form>
    <el-table v-loading="loading" :data="tableData" border>
      <el-table-column type="index" label="序号" align="center"></el-table-column>
      <el-table-column prop="countryName" label="国家名称" align="center"  :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="countryNameTc" label="英文名称" align="center" :show-overflow-tooltip="true"  ></el-table-column>
      <el-table-column prop="countryCode" label="国际编码" align="center"></el-table-column>
      <el-table-column prop="continent" label="大洲" align="center"></el-table-column>
      <el-table-column prop="operator" label="运营商名称" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="{row}">
          <el-tag type="success">{{row.operator}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="mccMnc" label="MccNnc" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" align="center" max-width="100" >
        <template slot-scope="{row}">
          <el-tag v-if="row.status == '1'" type="success">有效</el-tag>
          <el-tag v-else type="warning">无效</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />

  </div>
</template>
<script>
import { internationalOperatorPage } from "@/api/international.js";

export default {
  name: "InternationalOperatorList",
  data() {
    return {
      // 查询条件
      queryParams: {
        continent:undefined,
        countryName:undefined,
        operator:undefined,
        mccMnc:undefined
      },
      // 遮罩层
      loading: true,
      // 分页器
      page: 1,
      pageSize: 20,
      total: 10,
      // 列表数据
      tableData: [],
      
    };
  },
  methods: {
    // 搜索
    handleSearch() {
      this.initData();
    },
    // 获取列表
    initData() {
      this.loading=true;
      let params = {
        model:{
          ...this.queryParams
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      internationalOperatorPage(params).then(res => {
        this.loading=false;
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    }
  },
  mounted() {

  },
  created() {
    this.initData();
  },
};
</script>
<style scoped lang="less">
.tree-border{
  height: calc(100vh - 600px);
  overflow-y: auto;
}
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}

</style>
